import { render, staticRenderFns } from "./query-item.vue?vue&type=template&id=05122986&scoped=true"
import script from "./query-item.vue?vue&type=script&lang=ts"
export * from "./query-item.vue?vue&type=script&lang=ts"
import style0 from "./query-item.vue?vue&type=style&index=0&id=05122986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05122986",
  null
  
)

export default component.exports